<template>
  <div>
    <v-container class="grey lighten-5">
      <v-row no-gutters class="pagination-table-header">
        <v-col col="12">
          <v-overlay :absolute="true" :value="isComponentLoading">
            <v-progress-circular indeterminate size="24"></v-progress-circular>
          </v-overlay>
          <v-card
            v-if="L.isEmpty(paginatedObject) || L.isEmpty(paginatedObject.data)"
            class="pa-3"
          >
            <p class="text-center mt-2">
              <v-icon>mdi-account-search-outline</v-icon>
              <b
              >&nbsp;&nbsp;{{
                  lang($store, 'sap/listings.contacts.not_found')
                }}&nbsp;&nbsp;</b
              >
              <v-icon>mdi-account-badge-outline</v-icon>
            </p>
          </v-card>
          <div v-else>
            <v-card
              v-for="(item, key) in paginatedObject.data"
              :key="key"
              :color="cardColor(item)"
              class="mx-auto pa-2 mb-2"
              outlined
              :class="{
                'black-listed': item.black_listed
              }"
            >
              <v-row>
                <v-col cols="12" md="6">
                  <v-list-item style="user-select: auto">
                    <v-list-item-content
                      :style="{ color: cardTextColor(item) }"
                    >
                      <div class="overline mb-1">
                        <v-chip
                          v-if="item.source && item.source !== sources.UNSET"
                          class="mr-2 mb-2"
                          :color="cardTextColor(item)"
                          outlined
                          :text-color="cardTextColor(item)"
                        >
                          {{
                            lang(
                              $store,
                              `sap/listings.global.filter.sources.${item.source}`,
                            )
                          }}
                        </v-chip>
                      </div>
                      <v-list-item-title
                        class="mb-1"
                        style="white-space: initial; font-size: 18px; line-height: 20px"
                      >
                        <span
                          v-if="item.bank_private"
                          style="vertical-align: sub"
                        >
                          <img
                            src="data:image/jpeg;base64,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"
                            alt=""
                          />
                        </span>
                        <small>
                          {{ item.name }}
                        </small>
                        <phone-chip
                          :small="true"
                          :color="cardTextColor(item)"
                          :text-color="cardTextColor(item)"
                          :phone="item.phone"
                          :note="item.phone_note"
                        />
                        <phone-chip
                          v-if="item.phone2"
                          :small="true"
                          :color="cardTextColor(item)"
                          :text-color="cardTextColor(item)"
                          :phone="item.phone2"
                          :note="item.phone2_note"
                        />
                      </v-list-item-title>
                      <v-list-item-subtitle
                        :style="{ color: cardTextColor(item) }"
                      >
                        {{ item.note }}
                      </v-list-item-subtitle>

                      <v-card-actions class="px-0">
                        <v-btn
                          v-if="item.additional_info"
                          text
                          icon
                          :color="cardTextColor(item)"
                          @click="onPreview(item)"
                        >
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                        <v-btn
                          text
                          icon
                          :color="cardTextColor(item)"
                          @click="onItemEdit(item)"
                        >
                          <v-icon>mdi-account-edit-outline</v-icon>
                        </v-btn>
                        <v-btn
                          text
                          icon
                          :color="cardTextColor(item)"
                          @click="onItemDelete(item)"
                        >
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                        <v-btn
                          :to="{
                            name: 'contacts.subscriptions',
                            params: { userUuid: item.uuid }
                          }"
                          text
                          icon
                          :color="cardTextColor(item)"
                        >
                          <v-icon>mdi-credit-card-marker-outline</v-icon>
                          {{ item.active_subscriptions_count }}
                        </v-btn>
                      </v-card-actions>
                      <small v-if="item.subscription_activity">
                        {{ $t('clients.last_time_sub_offered') }}:
                        <b v-if="item.subscription_activity.contacted_at">{{
                            item.subscription_activity.contacted_at
                          }}</b>
                        <b v-else>{{ $t('clients.no_data') }}</b>
                      </small>
                      <small v-if="item.latest_base_order" class="mt-1">
                        {{ $t('clients.last_order_base_from') }} <b>{{
                          moment(item.latest_base_order)
                            .locale('ru')
                            .format('DD-MMMM-YYYY')
                        }}</b>
                      </small>
                      <small v-if="item.latest_complex_order" class="mt-1">
                        {{ $t('clients.last_order_complex_from') }} <b>{{
                          moment(item.latest_complex_order)
                            .locale('ru')
                            .format('DD-MMMM-YYYY')
                        }}</b>
                      </small>
                      <small class="mt-1">
                        {{ $t('clients.ltv_metric') }}: <b>{{ item.ltv_metrics }} грн</b>
                      </small>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="6" class="">
                  <v-alert text class="w-100">
                    <div v-if="item.addresses && item.addresses.length > 0">
                      <div
                        v-for="(address, index) in item.addresses"
                        :key="address.uuid"
                      >
                        <div class="d-flex align-center justify-space-between">
                          <div class="d-flex">
                            <premise-chip
                              :premises-type="
                                lang(
                                  $store,
                                  `sap/listings.global.filter.premises.${address.premises_type}`
                                )
                              "
                              :color="cardTextColor(item)"
                              :text-color="cardTextColor(item)"
                            />
                            <hoover class="mx-1" v-if="hooverModeEnable() && address.is_hoover"/>
                            <animals class="mx-1" v-if="address.has_animals"/>
                            <icon-tooltip
                              v-if="address.is_commerce"
                              icon="mdi-currency-usd"
                              text="Коммерция"
                              color="red"
                            />
                            <v-btn
                              v-if="address.additional_info"
                              text
                              icon
                              :color="cardTextColor(item)"
                              @click="onPreview(address)"
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                          </div>
                          <div class="d-flex">
                            <v-btn
                              text
                              icon
                              :color="cardTextColor(item)"
                              @click="onAddressEdit(item, address)"
                            >
                              <v-icon>mdi-lead-pencil</v-icon>
                            </v-btn>
                            <v-btn
                              text
                              icon
                              :color="cardTextColor(item)"
                              @click="onAddressDelete(item, address)"
                            >
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        <div>{{ address.formatted }}</div>
                        <div v-if="address.last_subscription">
                          <small>
                            {{ $t('clients.last_subscription') }}:
                            <strong>{{
                              moment(address.last_subscription.start)
                                .locale('ru')
                                .format('DD-MMMM-YYYY')
                            }}</strong>
                          </small>
                        </div>
                        <div v-if="address.subscription_first_order">
                          <small>
                            {{ $t('clients.subscription_first_order') }}:
                            <strong>{{
                              moment(address.subscription_first_order.datetime)
                                .locale('ru')
                                .format('DD-MMMM-YYYY')
                            }}</strong>
                          </small>
                        </div>

                        <v-divider
                          v-if="index !== item.addresses.length - 1"
                          class="my-4 info"
                          style="opacity: 0.22"
                        ></v-divider>
                      </div>
                    </div>
                    <div v-else>
                      <p class="text-center mt-2">
                        <v-icon class="white--text">mdi-home-group</v-icon>
                        <b
                        >&nbsp;&nbsp;{{
                            lang($store, 'sap/listings.address.not_found')
                          }}&nbsp;&nbsp;</b
                        >
                        <v-icon class="white--text">mdi-home-group</v-icon>
                      </p>
                    </div>
                  </v-alert>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

/* constants */
import hoover from '@/components/icons/hoover.vue';
import animals from '@/components/icons/animals.vue';
import IconTooltip from '@/components/minialerts/IconTooltip.vue';
import * as sources from '~constants/sources';
import { MANAGERS } from '@/constants/roles';
/* utils */
import settingsMixin from '@/mixins/settingsMixin';
import { roles as rolesColors } from '../../utils/listingColors';
/* mixins */
import isComponentLoading from '../../mixins/isComponentLoading';
import cardColorsMixin from '../../mixins/cardColorsMixin';
/* components */
import PhoneChip from '../minialerts/PhoneChip.vue';
import PremiseChip from '../minialerts/PremiseChip.vue';

export default {
  name: 'TablePaginatedContacts',
  mixins: [isComponentLoading, cardColorsMixin, settingsMixin],
  components: {
    PhoneChip,
    PremiseChip,
    hoover,
    animals,
    IconTooltip,
  },
  props: {
    paginatedObject: {
      type: Object,
      default: () => {
      },
    },
    noActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      moment,
      MANAGERS,
      rolesColors,
      sources,
      L: _,
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
  },
  methods: {
    onItemEdit(item) {
      this.$emit('edit-item', item);
    },
    onItemDelete(item) {
      this.$emit('delete-item', item);
    },
    onPreview(item) {
      this.$emit('preview-item', item);
    },

    onAddressEdit(item, address) {
      this.$emit('edit-address', {
        item,
        address,
      });
    },
    onAddressDelete(item, address) {
      this.$emit('delete-address', {
        item,
        address,
      });
    },
  },
};
</script>

<style lang="sass">
.black-listed
  position: relative

  &:before
    content: ''
    display: block
    position: absolute
    width: 100%
    height: 100%
    left: 0
    top: 0
    pointer-events: none
    background-image: url("/img/contacts/black_list.png")
    background-repeat: no-repeat
    background-position: center
    background-size: cover
    opacity: 0.15

.table-action
  &:hover
    fill: #0066ff
    transition: fill 0.5s
    cursor: pointer
</style>
